function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import * as React from "react";
import { Search } from "react-feather";
import Input from "./Input";
import { jsx as ___EmotionJSX } from "@emotion/core";

var SearchInput = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SearchInput, _React$Component);

  function SearchInput() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SearchInput.prototype;

  _proto.render = function render() {
    return ___EmotionJSX(Input, _extends({
      type: "search",
      icon: ___EmotionJSX(Search, null),
      borderRadius: "lg"
    }, this.props));
  };

  return SearchInput;
}(React.Component);

export { SearchInput as default };